export default __webpack_public_path__ + "static/desk11-d6e27201f42a10e295f2a2217c843ae8.png";